// import React, { useState, useEffect, useContext, Fragment } from "react";
// import axios from "axios";
// import { useNavigate, useParams } from "react-router-dom";
// import { Toaster, toast } from "react-hot-toast";
// import { Dialog, Transition } from "@headlessui/react";
// import {
//   Wallet,
//   IndianRupee,
//   CalendarDays,
//   ArrowLeft,
//   Loader2,
//   Banknote,
// } from "lucide-react";
// import Pagination from "./Pagination";

// import { GlobalContext } from "../../../Context/GlobalContext";

// const PayOut = () => {
//   const { baseUrl, config } = useContext(GlobalContext);
//   const navigate = useNavigate();
//   const { userId, orgName } = useParams();

//   // Use userId from route as userid for APIs
//   const userID = userId;
//   const clientName = orgName ? decodeURIComponent(orgName) : "";

//   const [loading, setLoading] = useState(false);
//   const [campaign, setCampaign] = useState([]);
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [wallet, setWallet] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 20;
//   const [bankInfo, setBankInfo] = useState([]);

//   // Settlement modal state
//   const [showModal, setShowModal] = useState(false);
//   const [settlementAmount, setSettlementAmount] = useState("");

//   const getCurrentDate = () => {
//     const today = new Date();
//     const year = today.getFullYear();
//     const month = String(today.getMonth() + 1).padStart(2, "0");
//     const day = String(today.getDate()).padStart(2, "0");
//     return `${year}-${month}-${day}`;
//   };

//   const walletBalanceApi = async () => {
//     try {
//       const requestBody = { userid: userID };
//       const response = await axios.post(
//         `${baseUrl}/Transactions/getWalletDetails`,
//         requestBody,
//         config
//       );

//       if (response.data?.responseCode === "00") {
//         setWallet(response.data.response || {});
//       } else {
//         setWallet({});
//       }
//     } catch (error) {
//       console.error("Wallet error:", error);
//       toast.error("Unable to load wallet balance.");
//     }
//   };

//   const getBankInfo = async () => {
//     try {
//       const payload = { userid: userID };
//       const response = await axios.post(
//         `${baseUrl}/Transactions/getSettlementAccountList`,
//         payload,
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       if (response.data?.responseCode === "00") {
//         setBankInfo(response.data.response || []);
//       } else {
//         setBankInfo([]);
//       }
//     } catch (error) {
//       console.error("Error bank info:", error);
//       toast.error("Unable to load bank details.");
//     }
//   };

//   const transactionsReportApi = async () => {
//     if (!startDate || !endDate) return;

//     try {
//       setLoading(true);
//       const raw = {
//         userid: userID,
//         fromDate: startDate,
//         toDate: endDate,
//       };

//       const res = await axios.post(
//         `${baseUrl}/Transactions/getAllPayouts`,
//         raw,
//         config
//       );

//       if (res.data?.responseCode === "00") {
//         setCampaign(res.data.response || []);
//       } else {
//         setCampaign([]);
//       }
//     } catch (error) {
//       console.error("Payout list error:", error);
//       toast.error("Unable to fetch payout report.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     const today = getCurrentDate();
//     setStartDate(today);
//     setEndDate(today);
//     getBankInfo();
//     walletBalanceApi();
//   }, [userID]);

//   useEffect(() => {
//     if (startDate && endDate) {
//       transactionsReportApi();
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [startDate, endDate]);

//   const handlePageClick = (page) => setCurrentPage(page);
//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage((p) => p + 1);
//   };
//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage((p) => p - 1);
//   };

//   const totalPages = Math.ceil(campaign.length / itemsPerPage) || 1;
//   const sortedCampaign = [...campaign].sort(
//     (a, b) => new Date(b.indate) - new Date(a.indate)
//   );
//   const displayedItems = sortedCampaign.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   const handleSettlement = async () => {
//     if (!settlementAmount) return;

//     try {
//       setLoading(true);
//       const requestBody = {
//         userid: userID,
//         amount: settlementAmount,
//         mode: "IMPS",
//       };

//       const response = await axios.post(
//         `${baseUrl}/Transactions/settlementProccess`,
//         requestBody,
//         config
//       );

//       if (response.data?.responseCode === "00") {
//         toast.success(response.data.responseMessage || "Settlement initiated.");
//         setShowModal(false);
//         setSettlementAmount("");
//         // Refresh wallet & report after settlement
//         walletBalanceApi();
//         transactionsReportApi();
//       } else {
//         toast.error(
//           response.data?.responseMessage || "Failed to process settlement."
//         );
//       }
//     } catch (error) {
//       console.error("Settlement error:", error);
//       toast.error("An error occurred while processing settlement.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="p-3 lg:p-5">
//       <Toaster position="top-right" />

//       {/* Header */}
//       <div className="mb-4 flex items-center justify-between gap-3">
//         <div className="flex items-center gap-3">
//           <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#01C37D]/10 text-[#01C37D]">
//             <Wallet size={18} />
//           </div>
//           <div>
//             <h1 className="text-xl font-semibold">
//               Payouts {clientName ? `– ${clientName}` : ""}
//             </h1>
//             <p className="text-sm text-gray-500">
//               View wallet balance, unsettled amount & payout history for this
//               client.
//             </p>
//           </div>
//         </div>
//         <button
//           onClick={() => navigate(-1)}
//           className="inline-flex items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs hover:bg-gray-50"
//         >
//           <ArrowLeft size={14} /> Back
//         </button>
//       </div>

//       {/* Top cards: Wallet + Bank details */}
//       <div className="grid gap-3 md:grid-cols-[2fr,3fr]">
//         {/* Wallet + filters + settlement button */}
//         <div className="rounded-2xl border bg-white p-4">
//           <div className="mb-3 flex items-center justify-between gap-3">
//             <div>
//               <div className="text-xs font-semibold text-gray-500">
//                 Wallet Balance
//               </div>
//               <div className="flex items-center gap-1 text-2xl font-bold text-emerald-600">
//                 <IndianRupee size={18} />
//                 {parseFloat(wallet.wallet_bal || 0.0).toFixed(2)}
//               </div>
//             </div>
//             <div>
//               <div className="text-xs font-semibold text-gray-500">
//                 Unsettled Amount
//               </div>
//               <div className="flex items-center gap-1 text-lg font-semibold text-amber-600">
//                 <IndianRupee size={16} />
//                 {parseFloat(wallet.unsettled_Amount || 0.0).toFixed(2)}
//               </div>
//             </div>
//           </div>

//           <div className="mt-3 grid gap-3 md:grid-cols-2">
//             <div className="flex flex-col gap-1">
//               <span className="flex items-center gap-1 text-xs font-medium text-gray-600">
//                 <CalendarDays size={14} /> From
//               </span>
//               <input
//                 type="date"
//                 value={startDate}
//                 onChange={(e) => setStartDate(e.target.value)}
//                 className="h-9 rounded-xl border px-2 text-xs outline-none"
//               />
//             </div>
//             <div className="flex flex-col gap-1">
//               <span className="flex items-center gap-1 text-xs font-medium text-gray-600">
//                 <CalendarDays size={14} /> To
//               </span>
//               <input
//                 type="date"
//                 value={endDate}
//                 onChange={(e) => setEndDate(e.target.value)}
//                 className="h-9 rounded-xl border px-2 text-xs outline-none"
//               />
//             </div>
//           </div>

//           <div className="mt-4 flex justify-end">
//             <button
//               type="button"
//               onClick={() => {
//                 setSettlementAmount("");
//                 setShowModal(true);
//               }}
//               className="inline-flex items-center gap-1.5 rounded-xl bg-[#01C37D] px-3 py-2 text-xs font-semibold text-white hover:bg-[#01af70]"
//             >
//               <Banknote size={14} /> New Settlement
//             </button>
//           </div>
//         </div>

//         {/* Bank details */}
//         <div className="rounded-2xl border bg-white p-4">
//           <div className="mb-2 flex items-center justify-between">
//             <h2 className="text-sm font-semibold">Settlement Bank Details</h2>
//           </div>
//           <div className="space-y-2">
//             {bankInfo.length === 0 && (
//               <div className="rounded-xl border border-dashed border-gray-200 p-3 text-xs text-gray-500">
//                 No settlement account configured for this client.
//               </div>
//             )}
//             {bankInfo.map((info) => (
//               <div
//                 key={info.id}
//                 className="rounded-xl border bg-slate-50 px-3 py-2 text-xs"
//               >
//                 <div className="flex justify-between gap-2 py-0.5">
//                   <span className="text-gray-500">Account Number</span>
//                   <span className="font-semibold">{info.us_account}</span>
//                 </div>
//                 <div className="flex justify-between gap-2 py-0.5">
//                   <span className="text-gray-500">IFSC Code</span>
//                   <span className="font-semibold">{info.ifsc_code}</span>
//                 </div>
//                 <div className="flex justify-between gap-2 py-0.5">
//                   <span className="text-gray-500">Bank Name</span>
//                   <span className="font-semibold capitalize">
//                     {info.bank_name}
//                   </span>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Payout table */}
//       <div className="mt-4 rounded-2xl border bg-white">
//         <div className="border-b px-4 py-3">
//           <div className="flex items-center justify-between">
//             <h2 className="text-sm font-semibold">Payout Report</h2>
//             {loading && (
//               <div className="inline-flex items-center gap-1 text-xs text-gray-500">
//                 <Loader2 size={14} className="animate-spin" /> Loading…
//               </div>
//             )}
//           </div>
//         </div>

//         <div className="max-h-[60vh] overflow-auto">
//           <table className="min-w-full text-xs">
//             <thead className="sticky top-0 z-10 bg-[#01C37D] text-[11px] uppercase tracking-wide text-white">
//               <tr>
//                 <th className="px-3 py-2 text-center">S.No.</th>
//                 <th className="px-3 py-2 text-center">Date</th>
//                 <th className="px-3 py-2 text-center">Reference No.</th>
//                 <th className="px-3 py-2 text-center">Account No.</th>
//                 <th className="px-3 py-2 text-center">Opening Balance</th>
//                 <th className="px-3 py-2 text-center">Amount</th>
//                 <th className="px-3 py-2 text-center">Charges</th>
//                 <th className="px-3 py-2 text-center">GST</th>
//                 <th className="px-3 py-2 text-center">Closing Balance</th>
//                 <th className="px-3 py-2 text-center">Status</th>
//               </tr>
//             </thead>
//             <tbody>
//               {displayedItems.length === 0 ? (
//                 <tr>
//                   <td
//                     colSpan={10}
//                     className="px-4 py-6 text-center text-xs text-gray-500"
//                   >
//                     No payout records found for the selected date range.
//                   </td>
//                 </tr>
//               ) : (
//                 displayedItems
//                   .slice()
//                   .reverse()
//                   .map((item, index) => (
//                     <tr
//                       key={`${item.rrn || "row"}-${index}`}
//                       className="border-t text-center text-[11px]"
//                     >
//                       <td className="px-3 py-2 align-middle">
//                         {(currentPage - 1) * itemsPerPage + index + 1}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.created_on}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.rrn || "NA"}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.account_no}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.before_bal}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.amount}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.charges}
//                       </td>
//                       <td className="px-3 py-2 align-middle">{item.gst}</td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.after_bal}
//                       </td>
//                       <td className="px-3 py-2 align-middle">
//                         {item.status === "SUCCESS" ? (
//                           <span className="inline-flex items-center justify-center rounded-full border border-emerald-600 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
//                             Success
//                           </span>
//                         ) : (
//                           <span className="inline-flex items-center justify-center rounded-full border border-rose-500 px-2 py-0.5 text-[10px] font-semibold text-rose-600">
//                             {item.status}
//                           </span>
//                         )}
//                       </td>
//                     </tr>
//                   ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination footer */}
//         <div className="border-t px-4 py-3">
//           <Pagination
//             currentPage={currentPage}
//             totalPages={totalPages}
//             onNextPage={handleNextPage}
//             onPrevPage={handlePrevPage}
//             onPageClick={handlePageClick}
//           />
//         </div>
//       </div>

//       {/* Settlement modal */}
//       <Transition show={showModal} as={Fragment}>
//         <Dialog
//           as="div"
//           className="relative z-50"
//           onClose={() => !loading && setShowModal(false)}
//         >
//           <Transition.Child
//             as={Fragment}
//             enter="ease-out duration-150"
//             enterFrom="opacity-0"
//             enterTo="opacity-100"
//             leave="ease-in duration-100"
//             leaveFrom="opacity-100"
//             leaveTo="opacity-0"
//           >
//             <div className="fixed inset-0 bg-black/40" />
//           </Transition.Child>

//           <div className="fixed inset-0 flex items-center justify-center p-4">
//             <Transition.Child
//               as={Fragment}
//               enter="ease-out duration-150"
//               enterFrom="opacity-0 scale-95"
//               enterTo="opacity-100 scale-100"
//               leave="ease-in duration-100"
//               leaveFrom="opacity-100 scale-100"
//               leaveTo="opacity-0 scale-95"
//             >
//               <Dialog.Panel className="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl">
//                 <Dialog.Title className="flex items-center gap-2 text-base font-semibold">
//                   <Banknote size={18} className="text-[#01C37D]" />
//                   New Settlement
//                 </Dialog.Title>

//                 <div className="mt-3 space-y-3 text-sm">
//                   <div className="rounded-xl border bg-slate-50 px-3 py-2 text-xs">
//                     <div className="flex justify-between">
//                       <span className="text-gray-500">Wallet Balance</span>
//                       <span className="font-semibold text-emerald-700">
//                         <IndianRupee size={12} className="inline" />{" "}
//                         {parseFloat(wallet.wallet_bal || 0.0).toFixed(2)}
//                       </span>
//                     </div>
//                     <div className="mt-1 flex justify-between">
//                       <span className="text-gray-500">Unsettled Amount</span>
//                       <span className="font-semibold text-amber-700">
//                         <IndianRupee size={12} className="inline" />{" "}
//                         {parseFloat(wallet.unsettled_Amount || 0.0).toFixed(2)}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="flex flex-col gap-1">
//                     <label className="text-xs font-medium text-gray-600">
//                       Settlement Amount
//                     </label>
//                     <div className="relative">
//                       <span className="pointer-events-none absolute inset-y-0 left-2 flex items-center text-gray-400">
//                         <IndianRupee size={14} />
//                       </span>
//                       <input
//                         type="number"
//                         value={settlementAmount}
//                         onChange={(e) =>
//                           setSettlementAmount(e.target.value.trim())
//                         }
//                         placeholder="Enter settlement amount"
//                         className="h-10 w-full rounded-xl border px-7 text-sm outline-none"
//                       />
//                     </div>
//                   </div>
//                 </div>

//                 <div className="mt-5 flex justify-end gap-2">
//                   <button
//                     className="h-9 rounded-xl border px-3 text-sm"
//                     onClick={() => setShowModal(false)}
//                     disabled={loading}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     className="inline-flex h-9 items-center gap-1.5 rounded-xl bg-[#01C37D] px-4 text-sm font-semibold text-white hover:bg-[#01af70] disabled:opacity-60"
//                     onClick={handleSettlement}
//                     disabled={!settlementAmount || loading}
//                   >
//                     {loading && (
//                       <Loader2 size={14} className="animate-spin" />
//                     )}
//                     {loading ? "Processing…" : "Proceed"}
//                   </button>
//                 </div>
//               </Dialog.Panel>
//             </Transition.Child>
//           </div>
//         </Dialog>
//       </Transition>
//     </div>
//   );
// };

// export default PayOut;

import React, { useState, useEffect, useContext, Fragment } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { Dialog, Transition } from "@headlessui/react";
import {
  Wallet,
  IndianRupee,
  CalendarDays,
  ArrowLeft,
  Loader2,
  Banknote,
} from "lucide-react";
import Pagination from "./Pagination";

import { GlobalContext } from "../../../Context/GlobalContext";

import useSettlement from "../../Services/OrderServices/SettlementServices/useSettlement";
import useOrderSettings from "../../Services/OrderServices/OrderSettingsServices/useOrderSettings";
const PayOut = () => {
  const {getWalletDetails, getAllPayouts, settlementProcess}=useSettlement();
  const {getSettlementAccountList}=useOrderSettings();

  const { baseUrl, api } = useContext(GlobalContext); // ⬅️ use api from context
  const navigate = useNavigate();
  const { userId, orgName,clientId } = useParams();

  // Use userId from route as userid for APIs
  const userID = userId ||clientId;
  const clientName = orgName ? decodeURIComponent(orgName) : "";

  const [loading, setLoading] = useState(false);
  const [campaign, setCampaign] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [wallet, setWallet] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [bankInfo, setBankInfo] = useState([]);

  // Settlement modal state
  const [showModal, setShowModal] = useState(false);
  const [settlementAmount, setSettlementAmount] = useState("");

  const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

const walletBalanceApi = async () => {
  if (!userID) return;

  try {
    const result =
      await getWalletDetails(userID);

    if (result.success) {
      setWallet(result.data);
    } else {
      setWallet({});
    }
  } catch (error) {
    console.error("Wallet error:", error);
    setWallet({});
    toast.error("Unable to load wallet balance.");
  }
};


const getBankInfo = async () => {
  if (!userID) return;

  try {
    const result =
      await getSettlementAccountList(userID);

    if (result.success) {
      setBankInfo(result.data);
    } else {
      setBankInfo([]);
    }
  } catch (error) {
    console.error("Error bank info:", error);
    setBankInfo([]);
    toast.error("Unable to load bank details.");
  }
};


const transactionsReportApi = async () => {
  if (!startDate || !endDate) return;

  setLoading(true);

  try {
    const result =
      await getAllPayouts({
        userid: userID,
        fromDate: startDate,
        toDate: endDate,
      });

    if (result.success) {
      setCampaign(result.data);
    } else {
      setCampaign([]);
    }
  } catch (error) {
    console.error("Payout list error:", error);
    setCampaign([]);
    toast.error("Unable to fetch payout report.");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    const today = getCurrentDate();
    setStartDate(today);
    setEndDate(today);
    getBankInfo();
    walletBalanceApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userID]);

  useEffect(() => {
    if (startDate && endDate) {
      transactionsReportApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const handlePageClick = (page) => setCurrentPage(page);
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  const totalPages = Math.ceil(campaign.length / itemsPerPage) || 1;
  const sortedCampaign = [...campaign].sort(
    (a, b) => new Date(b.indate) - new Date(a.indate)
  );
  const displayedItems = sortedCampaign.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

const handleSettlement = async () => {
  if (!settlementAmount) return;

  setLoading(true);

  try {
    const result =
      await settlementProcess({
        userid: userID,
        amount: settlementAmount,
        mode: "IMPS",
      });

    if (result.success) {
      toast.success(result.message);

      setShowModal(false);
      setSettlementAmount("");

      // Refresh wallet & report
      walletBalanceApi();
      transactionsReportApi();
    } else {
      toast.error(result.message);
    }
  } catch (error) {
    console.error("Settlement error:", error);
    toast.error(
      "An error occurred while processing settlement."
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="p-3 lg:p-5">
      <Toaster position="top-right" />

      {/* Header */}
      <div className="mb-4 flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="grid h-10 w-10 place-items-center rounded-xl bg-[#01C37D]/10 text-[#01C37D]">
            <Wallet size={18} />
          </div>
          <div>
            <h1 className="text-xl font-semibold">
              Payouts {clientName ? `– ${clientName}` : ""}
            </h1>
            <p className="text-sm text-gray-500">
              View wallet balance, unsettled amount & payout history for this
              client.
            </p>
          </div>
        </div>
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs hover:bg-gray-50"
        >
          <ArrowLeft size={14} /> Back
        </button>
      </div>

      {/* Top cards: Wallet + Bank details */}
      <div className="grid gap-3 md:grid-cols-[2fr,3fr]">
        {/* Wallet + filters + settlement button */}
        <div className="rounded-2xl border bg-white p-4">
          <div className="mb-3 flex items-center justify-between gap-3">
            <div>
              <div className="text-xs font-semibold text-gray-500">
                Wallet Balance
              </div>
              <div className="flex items-center gap-1 text-2xl font-bold text-emerald-600">
                <IndianRupee size={18} />
                {parseFloat(wallet.wallet_bal || 0.0).toFixed(2)}
              </div>
            </div>
            <div>
              <div className="text-xs font-semibold text-gray-500">
                Unsettled Amount
              </div>
              <div className="flex items-center gap-1 text-lg font-semibold text-amber-600">
                <IndianRupee size={16} />
                {parseFloat(wallet.unsettled_Amount || 0.0).toFixed(2)}
              </div>
            </div>
          </div>

          <div className="mt-3 grid gap-3 md:grid-cols-2">
            <div className="flex flex-col gap-1">
              <span className="flex items-center gap-1 text-xs font-medium text-gray-600">
                <CalendarDays size={14} /> From
              </span>
              <input
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className="h-9 rounded-xl border px-2 text-xs outline-none"
              />
            </div>
            <div className="flex flex-col gap-1">
              <span className="flex items-center gap-1 text-xs font-medium text-gray-600">
                <CalendarDays size={14} /> To
              </span>
              <input
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className="h-9 rounded-xl border px-2 text-xs outline-none"
              />
            </div>
          </div>

          <div className="mt-4 flex justify-end">
            <button
              type="button"
              onClick={() => {
                setSettlementAmount("");
                setShowModal(true);
              }}
              className="inline-flex items-center gap-1.5 rounded-xl bg-[#01C37D] px-3 py-2 text-xs font-semibold text-white hover:bg-[#01af70]"
            >
              <Banknote size={14} /> New Settlement
            </button>
          </div>
        </div>

        {/* Bank details */}
        <div className="rounded-2xl border bg-white p-4">
          <div className="mb-2 flex items-center justify-between">
            <h2 className="text-sm font-semibold">Settlement Bank Details</h2>
          </div>
          <div className="space-y-2">
            {bankInfo.length === 0 && (
              <div className="rounded-xl border border-dashed border-gray-200 p-3 text-xs text-gray-500">
                No settlement account configured for this client.
              </div>
            )}
            {bankInfo.map((info) => (
              <div
                key={info.id}
                className="rounded-xl border bg-slate-50 px-3 py-2 text-xs"
              >
                <div className="flex justify-between gap-2 py-0.5">
                  <span className="text-gray-500">Account Number</span>
                  <span className="font-semibold">{info.us_account}</span>
                </div>
                <div className="flex justify-between gap-2 py-0.5">
                  <span className="text-gray-500">IFSC Code</span>
                  <span className="font-semibold">{info.ifsc_code}</span>
                </div>
                <div className="flex justify-between gap-2 py-0.5">
                  <span className="text-gray-500">Bank Name</span>
                  <span className="font-semibold capitalize">
                    {info.bank_name}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Payout table */}
      <div className="mt-4 rounded-2xl border bg-white">
        <div className="border-b px-4 py-3">
          <div className="flex items-center justify-between">
            <h2 className="text-sm font-semibold">Payout Report</h2>
            {loading && (
              <div className="inline-flex items-center gap-1 text-xs text-gray-500">
                <Loader2 size={14} className="animate-spin" /> Loading…
              </div>
            )}
          </div>
        </div>

        <div className="max-h-[60vh] overflow-auto">
          <table className="min-w-full text-xs">
            <thead className="sticky top-0 z-10 bg-[#01C37D] text-[11px] uppercase tracking-wide text-white">
              <tr>
                <th className="px-3 py-2 text-center">S.No.</th>
                <th className="px-3 py-2 text-center">Date</th>
                <th className="px-3 py-2 text-center">Reference No.</th>
                <th className="px-3 py-2 text-center">Account No.</th>
                <th className="px-3 py-2 text-center">Opening Balance</th>
                <th className="px-3 py-2 text-center">Amount</th>
                <th className="px-3 py-2 text-center">Charges</th>
                <th className="px-3 py-2 text-center">GST</th>
                <th className="px-3 py-2 text-center">Closing Balance</th>
                <th className="px-3 py-2 text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {displayedItems.length === 0 ? (
                <tr>
                  <td
                    colSpan={10}
                    className="px-4 py-6 text-center text-xs text-gray-500"
                  >
                    No payout records found for the selected date range.
                  </td>
                </tr>
              ) : (
                displayedItems
                  .slice()
                  .reverse()
                  .map((item, index) => (
                    <tr
                      key={`${item.rrn || "row"}-${index}`}
                      className="border-t text-center text-[11px]"
                    >
                      <td className="px-3 py-2 align-middle">
                        {(currentPage - 1) * itemsPerPage + index + 1}
                      </td>
                      <td className="px-3 py-2 align-middle">
                        {item.created_on}
                      </td>
                      <td className="px-3 py-2 align-middle">
                        {item.rrn || "NA"}
                      </td>
                      <td className="px-3 py-2 align-middle">
                        {item.account_no}
                      </td>
                      <td className="px-3 py-2 align-middle">
                        {item.before_bal}
                      </td>
                      <td className="px-3 py-2 align-middle">{item.amount}</td>
                      <td className="px-3 py-2 align-middle">{item.charges}</td>
                      <td className="px-3 py-2 align-middle">{item.gst}</td>
                      <td className="px-3 py-2 align-middle">
                        {item.after_bal}
                      </td>
                      <td className="px-3 py-2 align-middle">
                        {item.status === "SUCCESS" ? (
                          <span className="inline-flex items-center justify-center rounded-full border border-emerald-600 px-2 py-0.5 text-[10px] font-semibold text-emerald-700">
                            Success
                          </span>
                        ) : (
                          <span className="inline-flex items-center justify-center rounded-full border border-rose-500 px-2 py-0.5 text-[10px] font-semibold text-rose-600">
                            {item.status}
                          </span>
                        )}
                      </td>
                    </tr>
                  ))
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination footer */}
        <div className="border-t px-4 py-3">
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onNextPage={handleNextPage}
            onPrevPage={handlePrevPage}
            onPageClick={handlePageClick}
          />
        </div>
      </div>

      {/* Settlement modal */}
      <Transition show={showModal} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => !loading && setShowModal(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/40" />
          </Transition.Child>

          <div className="fixed inset-0 flex items-center justify-center p-4">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-150"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-100"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-lg rounded-2xl bg-white p-5 shadow-xl">
                <Dialog.Title className="flex items-center gap-2 text-base font-semibold">
                  <Banknote size={18} className="text-[#01C37D]" />
                  New Settlement
                </Dialog.Title>

                <div className="mt-3 space-y-3 text-sm">
                  <div className="rounded-xl border bg-slate-50 px-3 py-2 text-xs">
                    <div className="flex justify-between">
                      <span className="text-gray-500">Wallet Balance</span>
                      <span className="font-semibold text-emerald-700">
                        <IndianRupee size={12} className="inline" />{" "}
                        {parseFloat(wallet.wallet_bal || 0.0).toFixed(2)}
                      </span>
                    </div>
                    <div className="mt-1 flex justify-between">
                      <span className="text-gray-500">Unsettled Amount</span>
                      <span className="font-semibold text-amber-700">
                        <IndianRupee size={12} className="inline" />{" "}
                        {parseFloat(wallet.unsettled_Amount || 0.0).toFixed(2)}
                      </span>
                    </div>
                  </div>

                  <div className="flex flex-col gap-1">
                    <label className="text-xs font-medium text-gray-600">
                      Settlement Amount
                    </label>
                    <div className="relative">
                      <span className="pointer-events-none absolute inset-y-0 left-2 flex items-center text-gray-400">
                        <IndianRupee size={14} />
                      </span>
                      <input
                        type="number"
                        value={settlementAmount}
                        onChange={(e) =>
                          setSettlementAmount(e.target.value.trim())
                        }
                        placeholder="Enter settlement amount"
                        className="h-10 w-full rounded-xl border px-7 text-sm outline-none"
                      />
                    </div>
                  </div>
                </div>

                <div className="mt-5 flex justify-end gap-2">
                  <button
                    className="h-9 rounded-xl border px-3 text-sm"
                    onClick={() => setShowModal(false)}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button
                    className="inline-flex h-9 items-center gap-1.5 rounded-xl bg-[#01C37D] px-4 text-sm font-semibold text-white hover:bg-[#01af70] disabled:opacity-60"
                    onClick={handleSettlement}
                    disabled={!settlementAmount || loading}
                  >
                    {loading && <Loader2 size={14} className="animate-spin" />}
                    {loading ? "Processing…" : "Proceed"}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default PayOut;
